const routes = {
    HOME: '/',
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    MASTER_SUPPRESSION: '/master-suppression',
    MEGAN_SUPPRESSION: '/megan-suppression',
};
  
export default routes;